export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Растау"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бас тарту"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Иә"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Жалғастырғыңыз келетініне сенімдісіз бе?"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Крипто-активті жою"])}
}